import { useEffect, useRef, useState } from "react";
import Styles from "./Navbar.module.css";
import { FiUser } from "react-icons/fi";
import { RxDashboard, RxHamburgerMenu } from "react-icons/rx";
import { Link, useNavigate } from "react-router-dom";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import { useDispatch, useSelector } from "react-redux";
import "./Navbar.css";
import { PiShoppingCartLight } from "react-icons/pi";
import { BiLogOut } from "react-icons/bi";
import { LOGOUT } from "../Action/UserAction";
import { MdEvent, MdOutlineEventNote } from "react-icons/md";
import { RiWebcamLine } from "react-icons/ri";
import { IoMdContact } from "react-icons/io";

export default function Navbar2({ Page, setQuestionSec }) {
  const [HideMenu, setHideMenu] = useState(false);
  const [ActiveDashboard, setActiveDashboard] = useState(false);
  const [ActiveEvent, setActiveEvent] = useState(false);
  const { Login_User_Loading, Login_User, Login_User_Error } = useSelector(
    (state) => state.USER_LOGIN_REDUCER
  );
  const ref = useRef();
  const ref2 = useRef();

  const Mobile_Screen = window.innerWidth;
  const Navigate = useNavigate();
  const dispatch = useDispatch();

  const handleMenu = (e) => {
    e.preventDefault();
    setHideMenu(!HideMenu);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!ref?.current?.contains(event.target)) {
        setActiveDashboard(false);
      }
      // if (!ref2?.current?.contains(event.target)) {
      //   setActiveEvent(false);
      // }
    };
    document.addEventListener("mousedown", handleClickOutside);
  }, [ref, ref2]);

  useEffect(() => {
    const handleClickOutside2 = (event) => {
      if (!ref2?.current?.contains(event.target)) {
        setActiveEvent(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside2);
  }, [ref2]);

  return (
    // <navbar>
    //   <div className={Styles.Navbar}>
    //     <div>
    //       <img
    //         onClick={() => Navigate("/")}
    //         src="/assets/image/Logos/Testify_White_Logo.svg"
    //         alt="logo"
    //       />
    //     </div>
    //     <Drawer
    //       style={{ zIndex: "99990" }}
    //       open={HideMenu}
    //       onClose={handleMenu}
    //       direction="right"
    //       className="bla bla bla"
    //     >
    //       <div className={Styles.Navbar_Section3}>
    //         <div>
    //           <p
    //             className="nv_j"
    //             onClick={(e) => {
    //               if (Page === "Home") {
    //                 setQuestionSec(true);
    //                 handleMenu(e);
    //               } else {
    //                 Navigate("/");
    //               }
    //             }}
    //           >
    //             Find A Course
    //           </p>
    //         </div>
    //         <div>
    //           <p
    //             className="nv_j"
    //             onClick={() => {
    //               Navigate("/Course");
    //             }}
    //             style={
    //               Page === "Course"
    //                 ? {
    //                     backgroundColor: "#0b3eff",
    //                     color: "white",
    //                   }
    //                 : { textDecoration: "none" }
    //             }
    //           >
    //             All Courses
    //           </p>
    //         </div>
    //         <div>
    //           <p
    //             className="nv_j"
    //             onClick={() => {
    //               Navigate("/about-us");
    //             }}
    //             style={
    //               Page === "About Us"
    //                 ? {
    //                     textDecoration: "none",
    //                     backgroundColor: "#0b3eff",
    //                     color: "white",
    //                   }
    //                 : { textDecoration: "none" }
    //             }
    //           >
    //             About Us
    //           </p>
    //         </div>
    //         <div>
    //           <p
    //             onClick={() => {
    //               Navigate("/contact-us");
    //             }}
    //             className="nv_j"
    //             style={
    //               Page === "Contact Us"
    //                 ? {
    //                     textDecoration: "none",
    //                     backgroundColor: "#0b3eff",
    //                     color: "white",
    //                   }
    //                 : { textDecoration: "none" }
    //             }
    //           >
    //             <span>
    //               <IoMdContact />
    //             </span>
    //             <span> Contact Us</span>
    //           </p>
    //         </div>

    //         <div ref={ref2} className={Styles.Coordinator2}>
    //           <div>
    //             <p
    //               className="nv_j"
    //               onClick={() => setActiveEvent(!ActiveEvent)}
    //             >
    //               {" "}
    //               <span>
    //                 {" "}
    //                 <MdEvent />{" "}
    //               </span>
    //               <span> Events</span>
    //             </p>
    //           </div>
    //           <div
    //             className={
    //               ActiveEvent
    //                 ? `${Styles.Navbar_DropDown} ${Styles.active}`
    //                 : Styles.Navbar_DropDown
    //             }
    //           >
    //             <p onClick={(e) => Navigate("/ielts-pte-reality-test")}>
    //               <span>
    //                 <MdOutlineEventNote />
    //               </span>
    //               <span>TRT Event</span>
    //             </p>

    //             <p onClick={(e) => Navigate("/language-assessment-test")}>
    //               <span>
    //                 <MdOutlineEventNote />
    //               </span>
    //               <span>T-LAT Event</span>
    //             </p>
    //             <p onClick={(e) => Navigate("/testifyi-ielts-webinar")}>
    //               <span>
    //                 <RiWebcamLine />
    //               </span>
    //               <span>Webinar</span>
    //             </p>
    //           </div>
    //         </div>
    //         {Login_User ? (
    //           <div ref={ref} className={Styles.Coordinator}>
    //             <div
    //               className={Styles.Coordinator_top}
    //               onClick={() => setActiveDashboard(!ActiveDashboard)}
    //             >
    //               <div>
    //                 <h5 style={{ color: "white" }}>
    //                   {Login_User?.First_Name
    //                     ? Login_User?.First_Name +
    //                       " " +
    //                       (Login_User?.Last_Name ? Login_User?.Last_Name : "")
    //                     : ""}
    //                 </h5>
    //               </div>
    //               <div>
    //                 <img src="/assets/image/user.svg" alt="profile" />
    //               </div>
    //             </div>
    //             <div
    //               className={
    //                 ActiveDashboard
    //                   ? `${Styles.Navbar_DropDown} ${Styles.active}`
    //                   : Styles.Navbar_DropDown
    //               }
    //             >
    //               <p onClick={(e) => Navigate("/dashboard")}>
    //                 <span>
    //                   <RxDashboard />{" "}
    //                 </span>
    //                 <span>Dashboard</span>
    //               </p>
    //               <p onClick={(e) => dispatch(LOGOUT())}>
    //                 <span>
    //                   <BiLogOut />
    //                 </span>
    //                 <span>Logout</span>
    //               </p>
    //             </div>
    //           </div>
    //         ) : (
    //           <div className={Styles.Login}>
    //             <div
    //               className="nv_j"
    //               onClick={(e) => {
    //                 e.preventDefault();

    //                 Navigate("/login");
    //               }}
    //               style={
    //                 Page === "Login"
    //                   ? { backgroundColor: "#0b3eff", color: "white" }
    //                   : { background: "none" }
    //               }
    //             >
    //               <span>
    //                 <FiUser />
    //               </span>
    //               <span> Login </span>
    //             </div>
    //             <div
    //               className="nv_j"
    //               onClick={(e) => {
    //                 e.preventDefault();

    //                 Navigate("/signup");
    //               }}
    //               style={
    //                 Page === "SignUp"
    //                   ? { backgroundColor: "#0b3eff", color: "white" }
    //                   : { background: "none" }
    //               }
    //             >
    //               <span>
    //                 <FiUser />
    //               </span>
    //               <span>Sign up </span>
    //             </div>
    //           </div>
    //         )}
    //         <div>
    //           <p onClick={() => Navigate("/cart")} className="nv_j">
    //             <span>
    //               <PiShoppingCartLight />
    //             </span>
    //             <span>Cart</span>
    //           </p>
    //         </div>
    //       </div>
    //     </Drawer>
    //     {Mobile_Screen >= 780 ? (
    //       <div className={Styles.Navbar_Section2}>
    //         <div>
    //           <a
    //             onClick={() => {
    //               if (Page === "Home") {
    //                 setQuestionSec(true);
    //               } else {
    //                 Navigate("/");
    //               }
    //             }}
    //             style={{ textDecoration: "none" }}
    //           >
    //             <p>Find A Course</p>
    //           </a>
    //         </div>
    //         <div>
    //           <Link style={{ textDecoration: "none" }} to="/Course">
    //             <p>Our Courses</p>
    //           </Link>
    //         </div>
    //         <div>
    //           <Link style={{ textDecoration: "none" }} to="/about-us">
    //             <p>About Us</p>
    //           </Link>
    //         </div>
    //         <div>
    //           <Link style={{ textDecoration: "none" }} to="/contact-us">
    //             <p>Contact Us</p>
    //           </Link>
    //         </div>

    //         <div ref={ref2} className={Styles.Coordinator2}>
    //           <div>
    //             <p onClick={() => setActiveEvent(!ActiveEvent)}>Events</p>
    //           </div>

    //           <div
    //             className={
    //               ActiveEvent
    //                 ? `${Styles.Navbar_DropDown} ${Styles.active}`
    //                 : Styles.Navbar_DropDown
    //             }
    //           >
    //             <p onClick={(e) => Navigate("/ielts-pte-reality-test")}>
    //               <span>
    //                 {" "}
    //                 <MdOutlineEventNote />
    //               </span>
    //               <span>TRT Event</span>
    //             </p>

    //             <p onClick={(e) => Navigate("/language-assessment-test")}>
    //               <span>
    //                 <MdOutlineEventNote />
    //               </span>
    //               <span>T-LAT Event</span>
    //             </p>
    //             <p onClick={(e) => Navigate("/testifyi-ielts-webinar")}>
    //               <span>
    //                 <RiWebcamLine />
    //               </span>
    //               <span>Webinar</span>
    //             </p>
    //           </div>
    //         </div>

    //         {Login_User ? (
    //           <div ref={ref} className={Styles.Coordinator}>
    //             <div
    //               onClick={() => setActiveDashboard(!ActiveDashboard)}
    //               className={Styles.Coordinator_top}
    //             >
    //               <div>
    //                 <h5>
    //                   {Login_User?.First_Name
    //                     ? Login_User?.First_Name +
    //                       " " +
    //                       (Login_User?.Last_Name ? Login_User?.Last_Name : "")
    //                     : ""}
    //                 </h5>
    //               </div>
    //               <div>
    //                 <img src="/assets/image/user.svg" alt="profile" />
    //               </div>
    //             </div>
    //             <div
    //               className={
    //                 ActiveDashboard
    //                   ? `${Styles.Navbar_DropDown} ${Styles.active}`
    //                   : Styles.Navbar_DropDown
    //               }
    //             >
    //               <p onClick={(e) => Navigate("/dashboard")}>
    //                 <span>
    //                   {" "}
    //                   <RxDashboard />{" "}
    //                 </span>
    //                 <span>Dashboard</span>
    //               </p>
    //               <p onClick={(e) => dispatch(LOGOUT())}>
    //                 <span>
    //                   {" "}
    //                   <BiLogOut />
    //                 </span>
    //                 <span>Logout</span>
    //               </p>
    //             </div>
    //           </div>
    //         ) : (
    //           <div className={Styles.Login_Signup}>
    //             <div onClick={() => Navigate("/login")}>
    //               <span style={{ fontSize: "15px" }}>
    //                 <FiUser />
    //               </span>
    //               <span> Login </span>
    //             </div>
    //             <div
    //               onClick={() => Navigate("/signup")}
    //               style={{ backgroundColor: "#333333", color: "white" }}
    //             >
    //               Sign up
    //             </div>
    //           </div>
    //         )}
    //         <div
    //           onClick={() => Navigate("/cart")}
    //           style={{
    //             backgroundColor: "white",
    //             display: "flex",
    //             alignItems: "center",
    //             flexDirection: "column",
    //             gap: "0",
    //             cursor: "pointer",
    //           }}
    //         >
    //           <span
    //             style={{ color: "#333333", marginBottom: "-5px", padding: "0" }}
    //           >
    //             <PiShoppingCartLight />
    //           </span>
    //           <span>Cart</span>
    //         </div>
    //       </div>
    //     ) : (
    //       <div>
    //         <span style={{ fontSize: "30px" }} onClick={handleMenu}>
    //           <RxHamburgerMenu />
    //         </span>
    //       </div>
    //     )}
    //   </div>
    // </navbar>

    <section className="New_Navbar_2">
      <nav class="navbar">
        <div class="nav-container">
          {/* <!-- Logo/Brand --> */}
          <div class="nav-logo">
            <a href="#" class="logo-link">
              <img
                onClick={() => Navigate("/")}
                src="/assets/image/Logos/Testify_White_Logo.svg"
                alt="logo"
              />
              {/* <span class="logo-text">
                  TEST<span class="logo-accent">i</span>FYI
                </span>
                <span class="logo-tagline">LEARN • TEST • ACHIEVE</span> */}
            </a>
          </div>

          {/* <!-- Mobile Menu Toggle --> */}
          <input type="checkbox" id="nav-toggle" class="nav-toggle" />
          <label for="nav-toggle" class="nav-toggle-label">
            <span class="hamburger"></span>
            <span class="hamburger"></span>
            <span class="hamburger"></span>
          </label>

          {/* <!-- Navigation Menu --> */}
          <div class="nav-menu">
            <ul class="nav-list">
              <li class="nav-item">
                <Link to="/about-us" class="nav-link">
                  About Us
                </Link>
              </li>

              {/* <!-- Courses with Multi-level Dropdown --> */}
              <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle">
                  Courses
                  <span class="dropdown-arrow">▼</span>
                </a>
                <ul class="dropdown-menu">
                  {/* <!-- IELTS with Sub-dropdown --> */}
                  <li class="dropdown-item sub-dropdown">
                    <a href="#" class="dropdown-link">
                      IELTS
                      <span class="sub-arrow">▶</span>
                    </a>
                    <ul class="sub-dropdown-menu">
                      <li class="sub-dropdown-item">
                        <Link
                          to="/ielts-coaching-in-delhi"
                          class="sub-dropdown-link"
                        >
                          IELTS Delhi
                        </Link>
                      </li>
                      <li class="sub-dropdown-item">
                        <Link
                          to="/ielts-coaching-in-chandigarh"
                          class="sub-dropdown-link"
                        >
                          IELTS Chandigarh
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li class="dropdown-item sub-dropdown">
                    <a href="#" class="dropdown-link">
                      PTE
                      <span class="sub-arrow">▶</span>
                    </a>
                    <ul class="sub-dropdown-menu">
                      <li class="sub-dropdown-item">
                        <Link
                          to="/pte-coaching-in-delhi"
                          class="sub-dropdown-link"
                        >
                          PTE Delhi
                        </Link>
                      </li>
                      <li class="sub-dropdown-item">
                        <Link
                          to="/pte-coaching-in-chandigarh"
                          class="sub-dropdown-link"
                        >
                          PTE Chandigarh
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li class="dropdown-item">
                    <a href="#" class="dropdown-link">
                      Duolingo
                    </a>
                  </li>
                  <li class="dropdown-item">
                    <a href="#" class="dropdown-link">
                      OET
                    </a>
                  </li>
                  <li class="dropdown-item">
                    <a href="#" class="dropdown-link">
                      General English
                    </a>
                  </li>
                </ul>
              </li>

              <li class="nav-item">
                <Link to="/Course" class="nav-link">
                  Packages
                </Link>
              </li>

              <li class="nav-item">
                <a href="#" class="nav-link">
                  Blogs
                </a>
              </li>
              <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle">
                  Test Prep
                  <span class="dropdown-arrow">▼</span>
                </a>
                <ul class="dropdown-menu">
                  {/* <!-- IELTS with Sub-dropdown --> */}
                  <li class="dropdown-item sub-dropdown">
                    <a href="#" class="dropdown-link">
                      IELTS Reality Test
                      <span class="sub-arrow">▶</span>
                    </a>
                    <ul class="sub-dropdown-menu">
                      {/* <li class="sub-dropdown-item">
                        <Link
                          to="/ielts-reality-test-in-delhi"
                          class="sub-dropdown-link"
                        >
                          Delhi
                        </Link>
                      </li> */}
                      <li class="sub-dropdown-item">
                        <Link
                          to="/ielts-reality-test-in-chandigarh"
                          class="sub-dropdown-link"
                        >
                          Chandigarh
                        </Link>
                      </li>
                    </ul>
                  </li>

                  <li class="dropdown-item">
                    <Link to="/language-assessment-test" class="dropdown-link">
                      T-LAT Event
                    </Link>
                  </li>
                  <li class="dropdown-item">
                    <Link to="/testifyi-ielts-webinar" class="dropdown-link">
                      Webinar
                    </Link>
                  </li>
                </ul>
              </li>

              <li class="nav-item">
                <Link to="/contact-us" class="nav-link">
                  Contact Us
                </Link>
              </li>
            </ul>

            {/* <!-- Auth & Cart Section --> */}
            <div class="nav-actions">
              {/* <!-- Cart Icon --> */}
              <Link to="/cart" class="cart-icon">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3 3H5L5.4 5M7 13H17L21 5H5.4M7 13L5.4 5M7 13L4.7 15.3C4.3 15.7 4.6 16.5 5.1 16.5H17M17 13V17C17 18.1 16.1 19 15 19H9C7.9 19 7 18.1 7 17V13M17 13H7"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <circle cx="9" cy="22" r="1" fill="currentColor" />
                  <circle cx="20" cy="22" r="1" fill="currentColor" />
                </svg>
                {/* <span class="cart-count">2</span> */}
              </Link>

              {/* <!-- Auth Buttons (shown when not logged in) --> */}
              {!Login_User ? (
                <div class="auth-buttons">
                  <Link to="/web-login" class="btn btn-login">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H15"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M10 17L15 12L10 7"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M15 12H3"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    Login
                  </Link>
                  <Link to="/signup" class="btn btn-signup">
                    Sign Up
                  </Link>
                </div>
              ) : (
                <div class="user-profile">
                  <div class="user-dropdown">
                    <button class="user-button">
                      <div class="user-avatar">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <circle
                            cx="12"
                            cy="7"
                            r="4"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      <span class="user-name">
                        {Login_User?.First_Name
                          ? Login_User?.First_Name +
                            " " +
                            (Login_User?.Last_Name ? Login_User?.Last_Name : "")
                          : ""}
                      </span>
                      <span class="dropdown-arrow">▼</span>
                    </button>
                    <ul class="user-dropdown-menu">
                      <li>
                        <Link
                          to="/student/details-update/6"
                          class="user-dropdown-link"
                        >
                          My Profile
                        </Link>
                      </li>
                      <li>
                        <Link to="/dashboard" class="user-dropdown-link">
                          My Dashboard
                        </Link>
                      </li>
                      {/* <li>
                      <a href="#" class="user-dropdown-link">
                        Settings
                      </a>
                    </li> */}
                      <li class="divider"></li>
                      <li>
                        <a
                          href="#"
                          onClick={(e) => dispatch(LOGOUT())}
                          class="user-dropdown-link logout"
                        >
                          Logout
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* <!-- Mobile Menu Overlay --> */}
          <div class="nav-overlay"></div>
        </div>
      </nav>
    </section>
  );
}
